@if (notification(); as notification) {
    <div
        id="outer-container"
        class="px-2 d-flex w-100 flex-column justify-content-center"
        [ngClass]="condensedView() ? 'mt-0' : 'mt-3'"
    >
        <div
            id="faculty-bulk-import-complete-notification-{{
                notification.FacultyBulkImportNotification?.BulkImportId
            }}"
            [ngClass]="condensedView() ? 'mb-0' : 'mb-2'"
        >
            <strong>Faculty import&nbsp;</strong>has been completed.

            @if (notification.FacultyBulkImportNotification?.Failed === 0) {
                {{ notification.FacultyBulkImportNotification?.Completed }}
                faculty {{ getCompletionVerb(notification.FacultyBulkImportNotification?.Completed) }} added to the
                institution.
            } @else {
                @let all =
                    notification.FacultyBulkImportNotification?.Failed +
                    notification.FacultyBulkImportNotification?.Completed;
                {{ notification.FacultyBulkImportNotification?.Completed }} of {{ all }} faculty
                {{ getCompletionVerb(all) }} added to the institution.
                {{ notification.FacultyBulkImportNotification?.Failed }}
                {{ getFacultyWord(notification.FacultyBulkImportNotification?.Failed) }} had errors which can be viewed
                in import history.
            }
        </div>
        <div [ngClass]="condensedView() ? 'mb-1' : 'mb-3'">
            <small>{{ date() }}</small>
        </div>
        <div class="d-flex" [ngClass]="condensedView() ? 'mb-1' : 'mb-3'">
            <button
                id="import-history-btn"
                type="button"
                class="text-nowrap my-1 btn btn-outline-secondary"
                [ngClass]="condensedView() ? 'btn-sm' : 'btn-md'"
                (click)="viewImportHistory(notification.FacultyBulkImportNotification?.BulkImportId)"
            >
                View Import History
            </button>
        </div>
    </div>
}
